module.exports = __webpack_public_path__ + "img/Gallery_2_04.0c215323.jpeg";